import React from 'react';

/**
 * The "grid" theme: photographs, and nothing else.
 *
 * The magazine spread narrates — editorial rows, a caption between each group.
 * Some galleries should not narrate: a client reviewing a shoot wants to scan
 * the work, and the quotes get in the way. So this is the same photos with the
 * commentary removed.
 *
 * Columns rather than a fixed grid, because uniform boxes force a choice
 * between cropping a photo and matting it — and this gallery has already
 * settled that a face must never be cropped. Flowing tiles keep every photo
 * whole at its own height while the column edges stay straight, which is what
 * makes the page read as tidy.
 *
 * Each tile reserves its photo's shape up front. Without that an unloaded
 * image is zero pixels tall, so every tile in the gallery would pile up inside
 * the viewport at once — and lazy loading, which only skips images below the
 * fold, would dutifully fetch all of them. Reserving the height also stops the
 * columns re-balancing under the reader as photos arrive.
 */
const GalleryGrid = ({ photos, ratios, onDownload }) => (
  <div className="pg-grid">
    {photos.map((photo) => {
      const ratio = ratios && ratios.get ? ratios.get(photo.id) : null;
      return (
      <div
        className="pg-grid-tile"
        key={photo.id}
        style={ratio ? { aspectRatio: String(ratio) } : undefined}
      >
        <img
          src={photo.image_url || photo.thumbnail_url}
          alt=""
          loading="lazy"
          decoding="async"
          draggable={false}
        />
        {onDownload && (
          <button
            className="pg-tile-download"
            onClick={(e) => onDownload(e, photo)}
            aria-label="Download photo"
            title="Download this photo"
          >
            <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14"><path d="M10 12.5a.75.75 0 0 0 .53-.22l3.5-3.5a.75.75 0 0 0-1.06-1.06L10.75 9.94V3a.75.75 0 0 0-1.5 0v6.94L7.03 7.72a.75.75 0 0 0-1.06 1.06l3.5 3.5c.14.14.33.22.53.22ZM4.75 13a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 6 18.25h8A2.75 2.75 0 0 0 16.75 15.5V13a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25V13Z"/></svg>
          </button>
        )}
      </div>
      );
    })}
  </div>
);

export default GalleryGrid;
